import { CREDIT_STATUS_ENUM } from '@/app/app/clients/common/enums/credit.enum.ts';

export const  CREDIT_STATUS_COLOR: Record<CREDIT_STATUS_ENUM, ColorStatus> = {
  [CREDIT_STATUS_ENUM.VALID]: 'success',
  [CREDIT_STATUS_ENUM.PROCESSING]: 'warning',
  [CREDIT_STATUS_ENUM.EXPIRED]: 'danger',
  [CREDIT_STATUS_ENUM.CANCELED]: 'danger',
}
